<template>
  <div class="novo-footer">
    <div class="qr-img">
      <img style="width: 80%; margin-top: 10%" :src="qrImg" alt="" />
    </div>

    <div>
      咨询电话：400-807-3636 |
      公司地址：北京市朝阳区霄云路35号乐势力广场3、4、5、6层
    </div>
    <div>
      氪空间NOVOBIT | © 2020 氪空间（北京）信息技术有限公司 |
      <a target="_blank" href="https://beian.miit.gov.cn/" style="color: #ffffff" >京ICP备16012805号-3</a>
    </div>
  </div>
</template>
<script>
export default {
  // name:'NovoFooter'
  data() {
    return {
      qrImg: require("common/image/qr/footr-qr.png"),
    };
  },
};
</script>

<style scoped lang="scss">
.novo-footer {
  position: relative;
  background: #323232;
  z-index: 10;
  padding-top: 40px;
  padding-bottom: 40px;
  text-align: center;
  font-size: 14px;
  color: #ffffff;
  line-height: 28px;

  .qr-img {
    width: 120px;
    height: 120px;
    display: inline-block;
    overflow: hidden;
    background: #ffffff;
    border-radius: 4px;
    margin-bottom: 20px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/novo-footer/index.vue